import validator from "validator";

const isEmail = value =>
  value && !validator.isEmail(value) && "Must be a valid email.";

export default isEmail;
